<template>
  <b-dropdown :class="textColor ? 'text-' + textColor : ''" variant="transparent" no-caret :right="context !== 'layout'">
    <template v-slot:button-content>
      <font-awesome-icon icon="ellipsis-v" :class="textColor ? 'timestamp text-' + textColor : 'timestamp'" />
    </template>
    <b-list-group flush>
      <b-dropdown-item-button @click="$emit('sync', device.id)" :disabled="deviceIsDeactivated || deviceConnectionIsDeleted">
        Sync
      </b-dropdown-item-button>
      <b-dd-divider v-if="canSyncScreenshot"/>
      <b-dropdown-item-button @click="$emit('sync-screenshot', device.id)" v-if="canSyncScreenshot" :disabled="deviceIsDeactivated">
        Sync Screenshot
      </b-dropdown-item-button>
      <b-dd-divider v-if="canManageDevice && (isUnassigned || isGroup) && !isChild" />
      <b-dropdown-item-button v-if="isUnassigned && canManageDevice && !isChild && !deviceConnectionIsDeleted" @click="$emit('assign', device)">
        Assign
      </b-dropdown-item-button>
      <b-dropdown-item-button v-if="isGroup && canManageDevice && !isChild" @click="$emit('unassign', device)">
        Unassign
      </b-dropdown-item-button>
      <b-dd-divider v-if="canReboot"/>
       <b-dropdown-item-button v-if="canReboot" @click="$emit('reboot', device)">
        Reboot
      </b-dropdown-item-button>
      <b-dd-divider v-if="isGroup && canManageDevice && !isChild && !deviceConnectionIsDeleted" />
      <b-dropdown-item-button v-if="isGroup && canManageDevice && !isChild && !deviceConnectionIsDeleted" @click="$emit('assign', device)">
        Change Group
      </b-dropdown-item-button>
      <b-dd-divider v-if="canManageDevice && !isUnassigned"/>
      <b-dropdown-item-button @click="$emit('deactivate', device.id)" v-if="!isUnassigned && canManageDevice && !deviceIsUserDeactivated">
        Deactivate
      </b-dropdown-item-button>
      <b-dropdown-item-button @click="$emit('activate', device.id)" v-if="deviceIsUserDeactivated && !isUnassigned && canManageDevice" :disabled="!canActivate">
        Activate
      </b-dropdown-item-button>
    </b-list-group>
  </b-dropdown>
</template>

<script>
import { REBOOTABLE_DEVICE_TYPES } from '@/constants/device-types';

export default {
	props: {
		textColor: {
			type: String,
			default: ''
		},
		canManageDevice: {
			type: Boolean,
			default: false
		},
		context: {
			default: 'layout',
			validator: (value) => {
				return [ 'group', 'unassigned', 'layout' ].indexOf(value) !== -1;
			}
		},
		device: {
			type: Object,
			required: true
		}
	},
	computed: {
		/**
     * determines if the options menu is in the group context
     *
     * @return {boolean}
     */
		isGroup () {
			return this.context === 'group';
		},
		/**
     * determines if the options menu is in the unassigned context
     *
     * @return {boolean}
     */
		isUnassigned () {
			return this.context === 'unassigned';
		},
		/**
     * determines if the device is deactivated
     *
     * @returns {boolean}
     */
		deviceIsDeactivated () {
			return this.deviceIsUserDeactivated || this.deviceIsSystemDeactivated;
		},
		/**
     * determines if the device is deactivated by user
     *
     * @returns {boolean}
     */
		deviceIsUserDeactivated () {
			return this.device.deactivated_at !== null;
		},
		/**
     * determines if the device is deactivated by system
     *
     * @returns {boolean}
     */
		deviceIsSystemDeactivated () {
			return this.device.system_deactivated_at !== null;
		},
		/**
     * determine if the device has access to the screenshot module
     *
     * @returns {boolean}
     */
		deviceHasScreenshotModule () {
			return this.device.modules.find(element => element.type === 'screenshot') !== undefined;
		},
		/**
     * determine if the device's connection has been deleted
     *
     * {boolean}
     */
		deviceConnectionIsDeleted () {
			return this.device.connection_deleted;
		},
		/**
     * determines if the device can be activated
     *
     * @returns {boolean}
     */
		canActivate () {
			return this.deviceIsUserDeactivated && !this.deviceConnectionIsDeleted;
		},
		/**
     * determines if screenshots can be synced for the device
     *
     * @return {boolean}
     */
		canSyncScreenshot () {
			return this.deviceHasScreenshotModule && !this.isUnassigned && !this.deviceConnectionIsDeleted;
		},
		/**
     * determines if the device is a child device
     *
     * @return {boolean}
     */
		isChild () {
			return this.device.parent_device_id !== null;
		},

		/**
     * determines if the device can be rebooted
     *
     * @return {boolean}
     */
		canReboot () {
			return this.canManageDevice && REBOOTABLE_DEVICE_TYPES.includes(this.device.device_type_name);
		}
	}
};
</script>

<style scoped>

</style>
